<template>
<div>
  <training-m :id="id" class="display-mobile"></training-m>
  <training-pc :id="id" class="display-pc"></training-pc>
</div>
</template>

<script>
import TrainingPc from './training-pc'
import TrainingM from './training-m'
// import Speaker from '../com-speaker'
// import moment from 'moment'
import util from '@/utils'

export default {
  data () {
    return {
    }
  },
  components: {
    TrainingPc,
    TrainingM
    // Speaker
  },
  props: [
  ],
  computed: {
    training () {
      return this.$store.state.topicsArr
    },
    id () {
      return this.$store.state.training.id
    },
    track () {
      return this.$store.state.topics[this.id] || { lectureIds: [] }
    }
    // trainings () {
    //   return this.track.lectureIds.map(id => this.$store.state.lectures[id])
    // },
    // speakerConfig () {
    //   return this.$store.state.speakerConfig
    // },
    // presentationTime () {
    //   return moment(this.track.time).utcOffset('+08:00').format('MM月DD日 hh:mm')
    // }
  },
  updated () {
    if (this.track.speaker) {
      util.weixinshare({
        imgUrl: this.track.speaker.avatar,
        title: this.track.topic + this.$store.state.config.wechat_share.default_title
      })
    }
  },
  mounted () {
    if (this.track.speaker) {
      util.weixinshare({
        imgUrl: this.track.speaker.avatar,
        title: this.track.topic + this.$store.state.config.wechat_share.default_title
      })
    }
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass"></style>
